import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import { getTravelEssenseDetails } from "../Actions/TourAction"

const mapStateToProps = (state) => {
    return {
        reducer: state.Tour
    }
}

const mapDispatchToProps = dispatch => ({
    getTravelEssenseDetails: () => dispatch(getTravelEssenseDetails())
});


function getActive(hash) {
    var active = 0
    switch (hash) {
        case "#section1":
            active = 1
            break;
        case "#section2":
            active = 2
            break;
        case "#section3":
            active = 3
            break;
        case "#section4":
            active = 4
            break;
        case "#section5":
            active = 5
            break;

        default:
            break;
    }
    return active
}


class TravelEssense extends Component {

    constructor(props) {
        super(props);
        const hash = window.location.hash;

        this.state = {
            list: getActive(hash)
        }

        this.props.getTravelEssenseDetails()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        this.scrollToHash();
    }
    componentDidUpdate(prevProps) {
        if (
            prevProps.reducer.travelEss !== this.props.reducer.travelEss &&
            this.props.reducer.travelEss
        ) {
            this.scrollToHash();
        }
    }

    scrollToHash = () => {
        const hash = window.location.hash;

        if (hash) {
            setTimeout(() => {
                const element = document.querySelector(hash);

                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                }
            }, 100);
        }
    };

    render() {
        var data = this.props.reducer.travelEss
        return <Fragment>
            <Header Home={false} />
            <div className="maindiv">
                <section className="contentwrap">
                    <div className="container2">

                        <div className="container">

                            <h2>Travel Essential</h2>
                            <div className="row">

                                {data != null ?
                                    <div className="col-md-12 col-sm-12 t-content">


                                        <div id="section1" style={{ scrollMarginTop: 180 }}>
                                            <h3>Accommodation</h3>

                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: data.accommodation }} />
                                            </p>
                                        </div>
                                        <div id="section2" style={{ scrollMarginTop: 80 }}>
                                            <h3>Security</h3>

                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: data.security }} />
                                            </p>
                                        </div>

                                        <div id="section3" style={{ scrollMarginTop: 150 }}>
                                            <h3>Telecommunication </h3>
                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: data.telecommunication }} />
                                            </p>

                                        </div>

                                        <div id="section4" style={{ scrollMarginTop: 130 }}>
                                            <h3>Emergency</h3>
                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: data.emergency }} />
                                            </p>
                                        </div>

                                        <div id="section5" style={{ scrollMarginTop: 130 }}>
                                            <h3>Visa & Documents</h3>
                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: data.visaDocuments }} />
                                            </p>

                                        </div>

                                        <div id="section6" style={{ scrollMarginTop: 130 }}>
                                            <h3>Language</h3>
                                            <p>
                                                <div dangerouslySetInnerHTML={{ __html: data.language }} />
                                            </p>
                                        </div>
                                    </div> : null}
                            </div>
                        </div>

                    </div>

                </section>

            </div>


            <Footer hyperLink={false} />

        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(TravelEssense);